import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Modal,
  Form,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import i18n from "../../../i18n";
import {
  applyProduct_InquiryDetails,
  getItemCategoryActiveList,
  getProductActiveListByCategoryID,
} from "../MeldiDhamCRUD";
import ElementPage from "../../Elements";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { addItem } from "../../../store/cartSlice";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { Spinner } from "reactstrap";

const CategoryListForHome = () => {
  const [products, setProducts] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [activeCategory, setActiveCategory] = useState(0);
  const [loading, setLoading] = useState(true);

  const pathUrl = process.env.REACT_APP_API_URL;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  /****************************************
   * Load Categories on Page Load
   *****************************************/
  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    setLoading(true);
    try {
      const res = await getItemCategoryActiveList();
      if (res.data.isSuccess) {
        setCategoryData(res.data.responseObject);
      }
      // getProducts(0);
      setLoading(false);
    } catch (err) {
      console.error("Category fetch error:", err);
      setLoading(false);
    }
  };

  /****************************************
   * Load Products by Category
   *****************************************/
  // const getProducts = async (categoryId) => {
  //   setLoading(true);
  //   try {
  //     const res = await getProductActiveListByCategoryID(categoryId);

  //     if (res.data.isSuccess) {
  //       setProducts(res.data.responseObject);
  //     } else {
  //       setProducts([]);
  //     }

  //     setActiveCategory(categoryId);
  //     setLoading(false);
  //   } catch (err) {
  //     console.error("Product fetch error:", err);
  //     setProducts([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleCategory = (categoryId) => {
  //   setActiveCategory(categoryId);
  //   getProducts(categoryId);
  // };

  const getLocalized = (item, field) => {
    const lang = i18n.language;
    if (lang === "gu") return item[`${field}_GJ`] || item[field];
    if (lang === "hi") return item[`${field}_HN`] || item[field];
    if (lang === "en") return item[`${field}_EN`] || item[field];
    return item[field];
  };

  /****************************************
   * Add to Cart
   *****************************************/
  const handleAddToCart = (prod) => {
    dispatch(
      addItem({
        id: prod.productID,
        prodCatgryID: prod.productCategoryID,
        name: getLocalized(prod, "productName"),
        categoryName: getLocalized(prod, "productCategoryName"),
        price: prod.price,
        image: prod.photoPath,
        qty: 1,
      })
    );
    toast.success(`${getLocalized(prod, "productName")} added to cart!`);
  };

  /****************************************
   * Inquiry Modal
  //  *****************************************/
  // const [showModal, setShowModal] = useState(false);
  // const [productID, setProductID] = useState(0);
  // const [productCategoryID, setProductCategoryID] = useState(0);
  // const [productName, setProductName] = useState("");
  // const [productCategoryName, setProductCategoryName] = useState("");

  // const {
  //   register,
  //   handleSubmit,
  //   reset,
  //   formState: { errors },
  // } = useForm();

  // const handleCloseModal = () => {
  //   reset();
  //   setShowModal(false);
  // };

  // const handleOpenModal = (
  //   selProductID,
  //   selProductName,
  //   selProductCategoryID,
  //   selProductCategoryName
  // ) => {
  //   setProductName(selProductName);
  //   setProductCategoryName(selProductCategoryName);
  //   setProductID(selProductID);
  //   setProductCategoryID(selProductCategoryID);
  //   setShowModal(true);
  // };

  // const onSubmit = async (data) => {
  //   try {
  //     const res = await applyProduct_InquiryDetails(
  //       data.name,
  //       "",
  //       data.contact,
  //       data.message,
  //       "192.168.0.1",
  //       data.terms,
  //       1,
  //       0,
  //       1,
  //       productID,
  //       productCategoryID
  //     );
  //     if (res.data.isSuccess) {
  //       alert("Inquiry submitted successfully!");
  //       reset();
  //       setShowModal(false);
  //     } else {
  //       alert("Failed to submit inquiry.");
  //     }
  //   } catch (error) {
  //     console.error("Error submitting inquiry:", error);
  //   }
  // };

  const navigate = useNavigate();
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <>
      <div className="py-8 px-2 container-fluid">
        {/**********************************
         * Category List
         ***********************************/}
        <div className="mb-4">
          <div className="row">
            <p className="text-decoration-none justify-content-center fs-4 text-dark me-2 badge  px-3 py-2 rounded-3">
              {t("categoryTitle")}
            </p>
          </div>
        </div>
        {loading ? (
          <div className="text-center my-5">
            <Spinner animation="border" />
          </div>
        ) : categoryData.length === 0 ? (
          <p className="text-center text-muted">No products found</p>
        ) : (
          <Row className="g-4 mt-3">
            {categoryData.map((cat) => {
              const isHover = hoveredId === cat.productCategoryID;

              return (
                <Col key={cat.productCategoryID} xs={12} sm={6} md={4} lg={3}>
                  <Card
                    className="border-0 cursor-pointer h-100"
                    style={{
                      // borderRadius: "14px",
                      overflow: "hidden",
                      transition: "all 0.35s ease",
                      boxShadow: isHover
                        ? "0 18px 38px rgba(0,0,0,0.18)"
                        : "0 8px 20px rgba(0,0,0,0.08)",
                      transform: isHover ? "translateY(-6px)" : "translateY(0)",
                    }}
                    onMouseEnter={() => setHoveredId(cat.productCategoryID)}
                    onMouseLeave={() => setHoveredId(null)}
                    onClick={() =>
                      navigate(`/category/${cat.productCategoryID}`, {
                        state: {
                          categoryName: getLocalized(
                            cat,
                            "productCategoryName"
                          ),
                        },
                      })
                    }
                  >
                    {/* IMAGE CONTAINER */}
                    <div
                      className="position-relative d-flex align-items-center justify-content-center"
                      style={{
                        height: "250px",
                        padding: "18px", // FIXED SPACING
                        // backgroundColor: "#f9fafb",
                        borderTopLeftRadius: "12px",
                        borderTopRightRadius: "12px",
                        overflow: "hidden",
                      }}
                    >
                      {/* IMAGE */}
                      <img
                        src={pathUrl + cat.photoPath}
                        alt={"no-image"}
                        style={{
                          maxWidth: "100vw",
                          maxHeight: "32vh",
                          objectFit: "cover",
                          transition: "transform 0.45s ease",
                          objectPosition: "center",
                          transform:
                            hoveredId === cat.productCategoryID
                              ? "scale(1.12)"
                              : "scale(1)",
                        }}
                      />

                      {/* HOVER OVERLAY */}
                      {isHover && (
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background:
                              "linear-gradient(180deg, rgba(0,0,0,0.2), rgba(0,0,0,0.5))",
                          }}
                        >
                          <button
                            className="btn btn-success px-4 py-2"
                            style={{
                              borderRadius: "30px",
                              fontWeight: 600,
                              fontSize: "14px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(`/category/${cat.productCategoryID}`);
                            }}
                          >
                            View Products
                          </button>
                        </div>
                      )}
                    </div>

                    {/* CATEGORY NAME */}
                    <Card.Body
                      className="text-center"
                      style={{
                        padding: "14px 10px",
                        backgroundColor: "#ffffff",
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          fontSize: "1.05rem",
                          fontWeight: 600,
                          color: "#2f7d32",
                        }}
                      >
                        {getLocalized(cat, "productCategoryName")}
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        )}
        {/* <h5
          className="mb-3 d-block text-center fw-bold mt-4"
          style={{ fontSize: "1.7rem", color: "#31572C" }}
        >
          Product List
        </h5> */}

        {/**********************************
         * 1️⃣ Loader
         ***********************************/}
        {/* {loading ? (
          <div className="text-center my-4">
            <div className="spinner-border text-primary">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
           
            {products.length === 0 ? (
              <div
                className="col-12 d-flex flex-column justify-content-center align-items-center text-center"
                style={{ minHeight: "80px" }}
              >
                <p className="fs-6 text-muted">{t("no_data")}</p>
              </div>
            ) : (
              <>
                <Row className="g-4">
                  {products.map((prod) => (
                    <Col key={prod.productID} xs={12} sm={6} md={3}>
                      <Card className="h-100 shadow-sm hover">
                        <Card.Img
                          variant="top"
                          src={pathUrl + prod.photoPath || ""}
                          alt={getLocalized(prod, "productName")}
                          style={{
                            height: "auto",
                            width: "100%",
                            maxHeight: "200px",
                            objectFit: "contain",
                            borderBottom: "1px solid #ddd",
                          }}
                        />

                        <Card.Body className="d-flex flex-column bg-light">
                          <Card.Title>
                            {getLocalized(prod, "productName")}
                          </Card.Title>

                          <div className="mt-auto d-flex justify-content-between">
                            <Button
                              style={{
                                backgroundColor: "#31572C",
                                border: "none",
                              }}
                              size="sm"
                              className="mt-2 fw-bold"
                              onClick={() =>
                                navigate(`/product/${prod.productID}`)
                              }
                            >
                              <i className="fas fa-eye px-1"></i> VIEW
                            </Button>

                            <Button
                              style={{
                                backgroundColor: "#31572C",
                                border: "none",
                              }}
                              size="sm"
                              className="mt-2 fw-bold"
                              onClick={() =>
                                handleOpenModal(
                                  prod.productID,
                                  prod.productName,
                                  prod.productCategoryID,
                                  prod.productCategoryName
                                )
                              }
                            >
                              INQUIRY NOW
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </>
            )}
          </>
        )} */}
      </div>

      {/**********************************
       * Inquiry Modal
       ***********************************/}
      {/* <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title className="text-yellow-500">
              Product Inquiry
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    {...register("name", { required: "Name is required" })}
                    placeholder="Enter your name"
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Mobile number"
                    maxLength={10}
                    {...register("contact", {
                      required: "Mobile number is required",
                      minLength: { value: 10, message: "Must be 10 digits" },
                      maxLength: { value: 10, message: "Must be 10 digits" },
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Only numbers allowed",
                      },
                    })}
                  />
                  {errors.contact && (
                    <small className="text-danger">
                      {errors.contact.message}
                    </small>
                  )}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3 h-100">
                  <Form.Control
                    as="textarea"
                    rows={8}
                    {...register("message", {
                      required: "Message is required",
                    })}
                    placeholder="Enter your message"
                  />
                  {errors.message && (
                    <small className="text-danger">
                      {errors.message.message}
                    </small>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Check
                  type="checkbox"
                  label="I agree to the terms and conditions"
                  {...register("terms", {
                    required: "You must accept the terms",
                  })}
                />
                {errors.terms && (
                  <small className="text-danger">{errors.terms.message}</small>
                )}
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="submit"
              style={{ backgroundColor: "#31572C", border: "none" }}
            >
              Submit
            </Button>
            <Button variant="danger" onClick={handleCloseModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal> */}
    </>
  );
};

export default CategoryListForHome;
